export default __webpack_public_path__ + "static/media/aden-red.7108e38f.png";